import { Action } from '../types/action';
import { Question } from '../types/question';

export type MakeComment<TId extends string> = (comment: {
  actions?: Array<Action>;
  next: Question<void, TId>['next'];
}) => Question<void, TId>;

export const createMakeComment =
  <TId extends string>(): MakeComment<TId> =>
  ({ actions, next }) => ({
    before: actions,
    getUserInput: () => Promise.resolve<void>(undefined),
    next,
  });
